/**
 * Platform-staff role helpers (mirrors the backend MarkupsUtils tier).
 *
 * ROLE_PLATFORM_ADMIN — full platform administrator.
 * ROLE_PLATFORM_USER  — restricted platform staff (TheMarkups engineers). Same platform surface
 *                       as an admin EXCEPT: cannot archive/restore an org, cannot remove a user,
 *                       and no billing access. Enforced authoritatively on the backend; the UI
 *                       just hides what the API would 403 anyway.
 *
 * Role is mirrored into localStorage('role') at login (see auth/session.js).
 */
export const PLATFORM_ADMIN = 'ROLE_PLATFORM_ADMIN';
export const PLATFORM_USER  = 'ROLE_PLATFORM_USER';

export function currentRole() {
  return localStorage.getItem('role') || '';
}

/** A full platform admin (not the restricted platform_user). */
export function isPlatformAdmin() {
  return currentRole() === PLATFORM_ADMIN;
}

/** The restricted platform_user role. */
export function isPlatformUser() {
  return currentRole() === PLATFORM_USER;
}

/** Either platform role — the set that may enter the admin console (/adminHome). */
export function isPlatformStaff() {
  const r = currentRole();
  return r === PLATFORM_ADMIN || r === PLATFORM_USER;
}
